import React, { useEffect, useState } from 'react';
/* import DashboardSeguimiento from './DashboardSeguimiento';
import DashboardSeguimientoIf from './DashboardSeguimientoIf'; */
import {/*  hasAnalistApps, */ validacionApps } from 'services/service.user';
//import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import GridContainer from '@jumbo/components/GridContainer';
import { Divider, Grid, Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';
//import LinkList from './LinkListFichasTecnicas';
//import DashboardFichasTecnicas from './DashboardFichasTecnicas';
//import { HourglassBottom, SendTimeExtension } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { TEXTO_FICHAS_TECNICAS } from '../FichasTecnicas/ConstsAndUtils/utils';
//import LinkList from './LinkList';
import { Description, FindInPage } from '@material-ui/icons';
import PageContainerDashboard from '@jumbo/components/PageComponents/layouts/PageContainerDasboard';


const SamplePage = () => {

  //const breadcrumbs = [{ label: 'inicio', isActive: true }];
  const { user } = useSelector(({ claveUnica }) => claveUnica);
  const [head, setHead] = useState('');
  const history = useHistory();
  const [prestador, setPrestador] = useState([{ label: 'inicio', isActive: true }])

  useEffect(() => {
    if (user) {
      var auxUser = {};
      try {
        auxUser = JSON.parse(user);
      } catch (error) {
        auxUser = user;
      }
      setHead("Buenos días, " + auxUser.names + " " + auxUser.last_name);
      setPrestador([{ label: auxUser.organization.name, isActive: true }])
    } else {
      setHead('Bienvenido - Extranet Superintendencia de Salud');
    }
  }, [user]);

  return (
    <div>
      <PageContainerDashboard heading={head} breadcrumbs={prestador}>
        <GridContainer>
          <Grid item xs={12}>
            <div style={{ marginBottom: 10 }}>
              {/* La Superintendencia de Salud, pone a disposición una plataforma web única con el fin de gestionar los distintos requerimientos que se generan entre la Superintendencia de Salud y las entidades externas. */}
              ¿Que deseas hacer?
            </div>
            <Divider />
          </Grid>
        </GridContainer>
      </PageContainerDashboard>

      <GridContainer>

        {validacionApps('Seguimiento de Reclamos') ?
          <Grid item xs={4}>
            <Grid
              item
              xs={12}
              style={{


                borderRadius: 15,
                cursor: 'pointer',
              }}>
              <Paper
                style={{
                  minHeight: 100,
                  //background: '#f5f5f5',
                  backgroundColor: 'white',
                  display: 'flex',
                  border: 'solid 1px',
                  borderColor: '#4a92d1'
                }}
                onClick={() => {
                  history.push('/pendientes');
                }}
                elevation={0}
              >
                <Grid container item justifyContent='space-around' alignItems='center'>
                  <Grid item xs={2} style={{ padding: 5, color: "#4a92d1" }}>
                    <FindInPage style={{ fontSize: "3rem" }} />
                  </Grid>
                  <Grid item xs={10}
                    style={{
                      padding: 5,
                      fontSize: "1rem",
                      color: "#4a92d1",

                    }}>
                    <div>Seguimiento y gestión de reclamos</div>

                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          :
          null}


        {validacionApps('Fichas Técnicas') ?

          <Grid item xs={4}>
            <Grid
              item
              xs={12}
              style={{
                borderRadius: 15,
                cursor: 'pointer',
              }}>
              <Paper
                style={{
                  minHeight: 100,
                  //background: '#f5f5f5',
                  backgroundColor: 'white',
                  display: 'flex',
                  border: 'solid 1px',
                  borderColor: '#4a92d1'
                }}
                onClick={() => {
                  history.push('/fichas_tecnicas');
                }}

                elevation={0}
              >
                <Grid container item justifyContent='space-around' alignItems='center'>
                  <Grid item xs={2} style={{ padding: 5, color: "#4a92d1" }}>
                    <Description style={{ fontSize: "3rem" }} />
                  </Grid>
                  <Grid item xs={10}
                    style={{
                      padding: 5,
                      fontSize: "1rem",
                      color: "#4a92d1",

                    }}>
                    <div>Registro y actualización Fichas técnicas</div>

                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          : null}




      </GridContainer>
      <p style={{ fontSize: 16, color: "#4a92d1", marginTop: 25, fontWeight: 'bold' }}>
        Portal de entidades externas Superintendencia de Salud
      </p>

      <p style={{ fontSize: 14, marginTop: 10 }}>
        {TEXTO_FICHAS_TECNICAS}
      </p>
      {
        //validacionApps('Seguimiento Reclamos Isapre/Fonasa') ? <DashboardSeguimientoIf key={2} /> : null
      }
      {/* <LinkList/> */}
    </div>
  );
};

export default SamplePage;
